import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface ExportResolver<P = Record<string, any>, T = any> {
  resolve(params: P): Observable<T>;
}

export interface ExportByTypeService<P = Record<string, any>, T = any> {
  execute(params: P): Observable<T>;
}

export const EXPORT_RESOLVER_TOKEN = new InjectionToken<ExportResolver>('ExportResolver');
